function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var StreamCapturer = require('../../lib/saito/ui/stream-capturer/stream-capturer');
var screenrecordWizard = require('./lib/screenrecord-wizard');
var ScreenRecordControls = require('./lib/screenrecord-lite-controls');
// lamejs@1.2.1 has a packaging bug: several of its internal files (Lame.js,
// BitStream.js, etc.) reference sibling classes as bare identifiers without
// requiring them, causing "X is not defined" errors in browser/bundler
// contexts. Exposing the classes globally before loading lamejs fixes it.
if (typeof globalThis !== 'undefined') {
  if (typeof globalThis.MPEGMode === 'undefined') {
    globalThis.MPEGMode = require('lamejs/src/js/MPEGMode');
  }
  if (typeof globalThis.Lame === 'undefined') {
    globalThis.Lame = require('lamejs/src/js/Lame');
  }
  if (typeof globalThis.BitStream === 'undefined') {
    globalThis.BitStream = require('lamejs/src/js/BitStream');
  }
}
var lamejs = require('lamejs');
var SaitoVideoBox = require('../../lib/saito/ui/saito-videobox/video-box');
var Record = /*#__PURE__*/function (_ModTemplate) {
  function Record(app) {
    var _this;
    _classCallCheck(this, Record);
    _this = _callSuper(this, Record, [app]);
    _this.app = app;
    _this.name = 'Screenrecord';
    _this.slug = 'screenrecord';
    _this.description = 'Recording Module';
    _this.categories = 'Utilities Communications';
    _this["class"] = 'utility';
    _this.status = 'prod';
    _this.record_video = false;
    _this.styles = ['/screenrecord/style.css'];
    _this.streamData = [];
    _this.chunks = [];
    _this.mediaRecorder = null;
    _this.is_capturing_stream = false;

    //
    // NOTE: there is deliberately no mid-recording stream swap here. The
    // StreamCapturer records through a stable canvas track + audio mixer
    // track, so layout changes and joining/leaving participants never
    // require restarting the MediaRecorder (which would either discard
    // earlier chunks or concatenate webm segments most players can't read).
    //

    _this.app.connection.on('interrupt-screen-recording', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(_this.type === 'game')) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            if (!((_this2 = _this) !== null && _this2 !== void 0 && _this2.mediaRecorder)) {
              _context.n = 2;
              break;
            }
            _context.n = 2;
            return _this.stopRecording();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));

    //
    // Someone joined the call after we started recording -- they never got
    // the original 'start recording' message, so tell them now (and add
    // them to members so our eventual 'stop recording' reaches them too)
    //
    _this.app.connection.on('videocall-add-party', function (publicKey) {
      if (!_this.mediaRecorder || _this.type !== 'videocall') {
        return;
      }
      if (publicKey === _this.publicKey) {
        return;
      }
      if (!_this.members.includes(publicKey)) {
        _this.members.push(publicKey);
      }
      _this.sendStartRecordingTransaction([publicKey], true);
    });
    return _this;
  }
  _inherits(Record, _ModTemplate);
  return _createClass(Record, [{
    key: "respondTo",
    value: function respondTo(type, obj) {
      var _this3 = this;
      if (type === 'record-actions') {
        this.attachStyleSheets();
        _superPropGet(Record, "render", this, 3)([this.app, this]);
        var is_recording = false;
        if (this.mediaRecorder) {
          is_recording = true;
        }
        return [{
          text: 'Record',
          icon: "fas fa-record-vinyl record-icon ".concat(this.mediaRecorder ? 'recording' : ''),
          hook: "record-container ".concat(this.mediaRecorder ? 'recording' : ''),
          callback: (/*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
              var container, streams, useMicrophone, callbackAfterRecord, members, screenRecordWizard;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    container = obj.container, streams = obj.streams, useMicrophone = obj.useMicrophone, callbackAfterRecord = obj.callbackAfterRecord, members = obj.members;
                    if (container) {
                      if (!this.mediaRecorder) {
                        screenRecordWizard = new screenrecordWizard(this.app, this, {
                          container: container,
                          members: members,
                          callbackAfterRecord: callbackAfterRecord,
                          type: 'videocall'
                        });
                        screenRecordWizard.render();
                      } else {
                        this.stopRecording();
                      }
                    }
                  case 1:
                    return _context2.a(2);
                }
              }, _callee2, this);
            }));
            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }()).bind(this)
        }];
      }
      if (type === 'screenrecord-videocall-limbo') {
        this.attachStyleSheets();
        _superPropGet(Record, "render", this, 3)([this.app, this]);
        var _is_recording = false;
        if (this.mediaRecorder) {
          _is_recording = true;
        }
        return {
          startStreamingVideoCall: function () {
            var _startStreamingVideoCall = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
              var stream, _t;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.p = _context3.n) {
                  case 0:
                    _context3.p = 0;
                    _this3.videoCallStreamCapturer = new StreamCapturer(_this3.app, _this3, _this3.logo);
                    stream = _this3.videoCallStreamCapturer.captureVideoCallStreams(true);
                    return _context3.a(2, stream);
                  case 1:
                    _context3.p = 1;
                    _t = _context3.v;
                    console.log('error streaming video call', _t);
                  case 2:
                    return _context3.a(2);
                }
              }, _callee3, null, [[0, 1]]);
            }));
            function startStreamingVideoCall() {
              return _startStreamingVideoCall.apply(this, arguments);
            }
            return startStreamingVideoCall;
          }(),
          stopStreamingVideoCall: function () {
            var _stopStreamingVideoCall = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.n) {
                  case 0:
                    if (_this3.videoCallStreamCapturer) {
                      _this3.videoCallStreamCapturer.stopCaptureVideoCallStreams();
                      _this3.videoCallStreamCapturer = null;
                    } else {
                      console.log('No stream to stop?');
                    }
                  case 1:
                    return _context4.a(2);
                }
              }, _callee4);
            }));
            function stopStreamingVideoCall() {
              return _stopStreamingVideoCall.apply(this, arguments);
            }
            return stopStreamingVideoCall;
          }()
        };
      }
      if (type === 'screenrecord-game-limbo') {
        this.attachStyleSheets();
        _superPropGet(Record, "render", this, 3)([this.app, this]);
        var _is_recording2 = false;
        if (this.mediaRecorder) {
          _is_recording2 = true;
        }
        return {
          startStreamingGame: function () {
            var _startStreamingGame = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(options) {
              var stream, includeCamera, container, _t2;
              return _regenerator().w(function (_context5) {
                while (1) switch (_context5.p = _context5.n) {
                  case 0:
                    _context5.p = 0;
                    includeCamera = options.includeCamera, container = options.container;
                    _this3.gameStreamCapturer = new StreamCapturer(_this3.app, _this3, _this3.logo);
                    _this3.gameStreamCapturer.view_window = container;
                    _context5.n = 1;
                    return _this3.gameStreamCapturer.captureGameStream(includeCamera);
                  case 1:
                    stream = _context5.v;
                    stream;
                    _this3.is_streaming_game = true;
                    return _context5.a(2, stream);
                  case 2:
                    _context5.p = 2;
                    _t2 = _context5.v;
                    console.log('error streaming video call', _t2);
                  case 3:
                    return _context5.a(2);
                }
              }, _callee5, null, [[0, 2]]);
            }));
            function startStreamingGame(_x2) {
              return _startStreamingGame.apply(this, arguments);
            }
            return startStreamingGame;
          }(),
          stopStreamingGame: function () {
            var _stopStreamingGame = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
              return _regenerator().w(function (_context6) {
                while (1) switch (_context6.n) {
                  case 0:
                    _this3.is_streaming_game = false;
                    if (_this3.gameStreamCapturer) {
                      _this3.gameStreamCapturer.stopCaptureGameStream();
                      _this3.gameStreamCapturer = null;
                    } else {
                      console.log('No stream to stop?');
                    }
                  case 1:
                    return _context6.a(2);
                }
              }, _callee6);
            }));
            function stopStreamingGame() {
              return _stopStreamingGame.apply(this, arguments);
            }
            return stopStreamingGame;
          }(),
          isCapturingStream: function isCapturingStream() {
            if (_this3.gameStreamCapturer) {
              return _this3.gameStreamCapturer.is_capturing_stream;
            } else {
              return false;
            }
          }
        };
      }
      if (type === 'game-menu') {
        this.attachStyleSheets();
        if (!obj.recordOptions) return;
        if (obj.recordOptions.active === false) {
          return;
        }
        var menu = {
          //id: 'game-share',
          //text: 'Share',
          submenus: []
        };
        menu.submenus.push({
          parent: 'game-share',
          text: 'Record game',
          id: 'record-stream',
          "class": 'record-stream',
          callback: (/*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(app, game_mod) {
              var _game_mod$recordOptio, container, callbackAfterRecord, screenRecordWizard;
              return _regenerator().w(function (_context7) {
                while (1) switch (_context7.n) {
                  case 0:
                    _game_mod$recordOptio = game_mod.recordOptions, container = _game_mod$recordOptio.container, callbackAfterRecord = _game_mod$recordOptio.callbackAfterRecord;
                    if (!this.mediaRecorder) {
                      screenRecordWizard = new screenrecordWizard(this.app, this, {
                        container: container,
                        members: game_mod.game.players,
                        callbackAfterRecord: callbackAfterRecord,
                        type: 'game'
                      });
                      screenRecordWizard.render();
                      game_mod.menu.hideSubMenus();
                    } else {
                      this.stopRecording();
                    }
                  case 1:
                    return _context7.a(2);
                }
              }, _callee7, this);
            }));
            return function (_x3, _x4) {
              return _ref3.apply(this, arguments);
            };
          }()).bind(this)
        });
        return menu;
      }

      // if (type === "dream-controls") {
      // 	let audioEnabled = true;
      // 	let videoIcon = this.videoBox ? "fas fa-video" : "fas fa-video-slash";
      // 	let audioIcon =  audioEnabled ? "fas fa-microphone" : 'fas fa-microphone-slash';

      // 	const streams = this.app.modules.getRespondTos('media-request');

      // 	let x = [
      // 		{
      // 			text: `Video control`,
      // 			icon: videoIcon,
      // 			callback: (app, id, combined_stream) => {
      // 				const iconElement = document.querySelector(`#dream_controls_menu_item_${id} i`);
      // 				if (this.videoBox) {
      // 					this.removeVideoBox(true);
      // 					iconElement.classList.replace('fa-video', 'fa-video-slash');
      // 				} else {
      // 					this.getOrCreateVideoBox();
      // 					iconElement.classList.replace('fa-video-slash', 'fa-video');
      // 				}
      // 			},
      // 			style: ""
      // 		},
      // 		{
      // 			text: `Audio control`,
      // 			icon: audioIcon,
      // 			callback: (app, id, combined_stream) => {
      // 				const iconElement = document.querySelector(`#dream_controls_menu_item_${id} i`);
      // 				let audioEnabled;
      // 				if(this.gameStreamCapturer.localStream){
      // 					audioEnabled = true
      // 				}else {
      // 					audioEnabled = false
      // 				}
      // 				if (audioEnabled) {
      // 					iconElement.classList.replace('fa-microphone', 'fa-microphone-slash');
      // 					this.gameStreamCapturer.stopLocalAudio()
      // 				} else {
      // 					iconElement.classList.replace('fa-microphone-slash', 'fa-microphone');
      // 					this.gameStreamCapturer.getLocalAudio()
      // 				}
      // 			},
      // 			style: ""
      // 		}
      // 	];

      // 	// Hide icons if videocall streams exist
      // 	if (streams.length > 0) {
      // 		x.forEach(control => {
      // 			control.style = 'hidden-control';
      // 		});
      // 	}

      // 	return x;
      // }
    }
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(app) {
        var tx,
          peer,
          mycallback,
          message,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              tx = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : null;
              peer = _args8.length > 2 ? _args8[2] : undefined;
              mycallback = _args8.length > 3 ? _args8[3] : undefined;
              if (!(tx == null)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              message = tx.returnMessage();
              if (!(message.module === 'screenrecord')) {
                _context8.n = 3;
                break;
              }
              if (!(this.app.BROWSER === 1)) {
                _context8.n = 3;
                break;
              }
              if (!this.hasSeenTransaction(tx)) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2);
            case 2:
              if (tx.isTo(this.publicKey) && !tx.isFrom(this.publicKey)) {
                this.receiveRecordingMessage(message, tx.from[0].publicKey);
              }
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function handlePeerTransaction(_x5) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "onConfirmation",
    value: function onConfirmation(blk, tx, conf) {
      if (tx == null) {
        return;
      }
      var message = tx.returnMessage();
      if (conf == 0) {
        if (message.module === 'screenrecord') {
          if (this.app.BROWSER === 1) {
            if (this.hasSeenTransaction(tx, blk)) return;
            if (tx.isTo(this.publicKey) && !tx.isFrom(this.publicKey)) {
              this.receiveRecordingMessage(message, tx.from[0].publicKey);
            }
          }
        }
      }
    }

    //
    // Shared handling for recording signals, which arrive over relay (instant)
    // and may be re-delivered on chain -- hasSeenTransaction dedupes the pair
    //
  }, {
    key: "receiveRecordingMessage",
    value: function receiveRecordingMessage(message, sender) {
      var username = this.app.keychain.returnUsername(sender);
      if (message.request === 'recording countdown') {
        this.showCountdown(message.seconds || 5, sender);
      }
      if (message.request === 'start recording') {
        //
        // message.ongoing means we joined a call that was already being
        // recorded -- word it in the present tense
        //
        siteMessage(message.ongoing ? "".concat(username, " is recording this call") : "".concat(username, " started recording their screen"), 2500);
        this.updateUIForRecordingStart(sender);
      }
      if (message.request === 'stop recording') {
        siteMessage("".concat(username, " stopped recording their screen"), 1500);
        this.updateUIForRecordingStop();
      }
    }
  }, {
    key: "onPeerHandshakeComplete",
    value: function onPeerHandshakeComplete() {
      if (this.app.BROWSER === 1) {
        this.logo = new Image();
        this.logo.src = '/saito/img/logo.svg';
      }
    }
  }, {
    key: "getOrCreateVideoBox",
    value: function () {
      var _getOrCreateVideoBox = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(stream) {
        var streams, stream_id, videoElement;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (this.videoBox) {
                _context9.n = 3;
                break;
              }
              streams = this.app.modules.getRespondTos('media-request');
              if (!(streams.length > 0)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              _context9.n = 2;
              return navigator.mediaDevices.getUserMedia({
                video: true
              });
            case 2:
              this.localStream = _context9.v;
              stream_id = "stream_".concat(this.publicKey);
              this.videoBox = new SaitoVideoBox(this.app, this, this.publicKey);
              this.videoBox.render(this.localStream);
              videoElement = document.querySelector('.saito-videobox');
              if (videoElement) {
                videoElement.style.position = 'absolute';
                videoElement.style.top = '100px';
                videoElement.style.width = '350px';
                videoElement.style.height = '350px';
                videoElement.style.resize = 'both';
                videoElement.style.overflow = 'auto';
                videoElement.classList.add('game-video-box');
                this.app.browser.makeDraggable(stream_id);
              }
            case 3:
              return _context9.a(2, this.videoBox);
          }
        }, _callee9, this);
      }));
      function getOrCreateVideoBox(_x6) {
        return _getOrCreateVideoBox.apply(this, arguments);
      }
      return getOrCreateVideoBox;
    }()
  }, {
    key: "removeVideoBox",
    value: function removeVideoBox() {
      var forceRemove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!forceRemove) {
        if (this.is_recording_game || this.is_streaming_game) {
          return;
        }
        if (this.videoBox) {
          this.localStream.getTracks().forEach(function (track) {
            track.stop();
          });
          this.localStream = null;
          this.videoBox.remove();
          this.videoBox = null;
        }
      } else {
        if (this.videoBox) {
          this.localStream.getTracks().forEach(function (track) {
            track.stop();
          });
          this.localStream = null;
          this.videoBox.remove();
          this.videoBox = null;
        }
      }
    }
  }, {
    key: "initializeMediaRecorder",
    value: function () {
      var _initializeMediaRecorder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(stream) {
        var _this4 = this;
        var mimeType, options, _t3;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              //
              // each recording starts fresh -- chunks from a previous session would
              // corrupt the output file
              //
              this.chunks = [];
              mimeType = stream.getVideoTracks().length > 0 ? 'video/webm; codecs="vp8, opus"' : 'audio/webm; codecs="opus"';
              options = {
                mimeType: mimeType,
                videoBitsPerSecond: stream.getVideoTracks().length > 0 ? 1.5 * 1024 * 1024 : undefined,
                audioBitsPerSecond: 320 * 1024
              };
              _context0.p = 1;
              if (MediaRecorder.isTypeSupported(mimeType)) {
                this.mediaRecorder = new MediaRecorder(stream, options);
              } else {
                console.warn("".concat(mimeType, " is not supported, using default codec"));
                this.mediaRecorder = new MediaRecorder(stream);
              }
              this.mediaRecorder.onstart = function (event) {
                console.log('media recorder started');
              };
              this.mediaRecorder.ondataavailable = function (event) {
                if (event.data.size > 0) {
                  console.log('new data available', event.data);
                  _this4.chunks.push(event.data);
                }
              };
              this.mediaRecorder.start();
              _context0.n = 3;
              break;
            case 2:
              _context0.p = 2;
              _t3 = _context0.v;
              console.error('Error creating MediaRecorder:', _t3);
              throw _t3;
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this, [[1, 2]]);
      }));
      function initializeMediaRecorder(_x7) {
        return _initializeMediaRecorder.apply(this, arguments);
      }
      return initializeMediaRecorder;
    }()
  }, {
    key: "startRecording",
    value: function () {
      var _startRecording = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(options) {
        var container, members, callbackAfterRecord, type, includeCamera, stream, _stream, recordButton;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              container = options.container, members = options.members, callbackAfterRecord = options.callbackAfterRecord, type = options.type, includeCamera = options.includeCamera;
              console.log(options, 'options');

              // initialize variables
              this.type = type;
              this.members = members;
              this.recording_target_selector = null;
              if (!(type === 'videocall')) {
                _context1.n = 1;
                break;
              }
              this.recorderVideoCallStreamCapture = new StreamCapturer(this.app, this, this.logo);
              this.recorderVideoCallStreamCapture.view_window = '.video-container-large';
              this.recording_target_selector = this.recorderVideoCallStreamCapture.view_window;
              stream = this.recorderVideoCallStreamCapture.captureVideoCallStreams(includeCamera);
              this.initializeMediaRecorder(stream);
              _context1.n = 3;
              break;
            case 1:
              if (!(type === 'game')) {
                _context1.n = 3;
                break;
              }
              this.gameRecordCapturer = new StreamCapturer(this.app, this, this.logo);
              this.gameRecordCapturer.view_window = container;
              this.recording_target_selector = container;
              this.is_recording_game = true;
              _context1.n = 2;
              return this.gameRecordCapturer.captureGameStream(includeCamera);
            case 2:
              _stream = _context1.v;
              this.initializeMediaRecorder(_stream);

              // show controls
              this.screenrecordControls = new ScreenRecordControls(this.app, this);
              this.screenrecordControls.render();
              recordButton = document.getElementById('record-stream');
              if (recordButton) {
                recordButton.textContent = 'Stop recording';
              }
            case 3:
              this.sendStartRecordingTransaction(members);
              this.updateUIForRecordingStart();
            case 4:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function startRecording(_x8) {
        return _startRecording.apply(this, arguments);
      }
      return startRecording;
    }()
  }, {
    key: "downloadMedia",
    value: function () {
      var _downloadMedia = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(url, type, callbackAfterRecord) {
        var defaultFileName, placeholder, a, fileName, _t4;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              defaultFileName = type === 'video' ? 'saito_video.webm' : 'saitio_audio.mp3';
              placeholder = type === 'video' ? 'saito_video' : 'saito_audio';
              a = document.createElement('a');
              a.style.display = 'none';
              a.href = url;
              _context10.n = 1;
              return sprompt('Please enter a recording name', placeholder);
            case 1:
              _t4 = _context10.v;
              if (_t4) {
                _context10.n = 2;
                break;
              }
              _t4 = defaultFileName;
            case 2:
              fileName = _t4;
              a.download = fileName;
              document.body.appendChild(a);
              a.click();
              setTimeout(function () {
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
              }, 100);
            // if (callbackAfterRecord) {
            // 	callbackAfterRecord(blob);
            // }
            // this.callbackAfterStopRecording()
            case 3:
              return _context10.a(2);
          }
        }, _callee10);
      }));
      function downloadMedia(_x9, _x0, _x1) {
        return _downloadMedia.apply(this, arguments);
      }
      return downloadMedia;
    }()
  }, {
    key: "processAudio",
    value: function () {
      var _processAudio = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(blob) {
        var audioContext, arrayBuffer, audioBuffer, mp3Encoder, samples, mp3Data, int16Samples, i, _i, chunk, _mp3buf, mp3buf, mp3Blob, url;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              audioContext = new (window.AudioContext || window.webkitAudioContext)();
              _context11.n = 1;
              return blob.arrayBuffer();
            case 1:
              arrayBuffer = _context11.v;
              _context11.n = 2;
              return audioContext.decodeAudioData(arrayBuffer);
            case 2:
              audioBuffer = _context11.v;
              mp3Encoder = new lamejs.Mp3Encoder(1, audioBuffer.sampleRate, 128);
              samples = audioBuffer.getChannelData(0);
              mp3Data = [];
              int16Samples = new Int16Array(samples.length);
              for (i = 0; i < samples.length; i++) {
                int16Samples[i] = samples[i] * 32767; // Convert float to int16
              }
              for (_i = 0; _i < int16Samples.length; _i += 576) {
                chunk = int16Samples.subarray(_i, _i + 576);
                _mp3buf = mp3Encoder.encodeBuffer(chunk);
                if (_mp3buf.length > 0) {
                  mp3Data.push(new Int8Array(_mp3buf));
                }
              }
              mp3buf = mp3Encoder.flush();
              if (mp3buf.length > 0) {
                mp3Data.push(new Int8Array(mp3buf));
              }
              mp3Blob = new Blob(mp3Data, {
                type: 'audio/mp3'
              });
              url = URL.createObjectURL(mp3Blob);
              return _context11.a(2, url);
          }
        }, _callee11);
      }));
      function processAudio(_x10) {
        return _processAudio.apply(this, arguments);
      }
      return processAudio;
    }()
  }, {
    key: "stopRecording",
    value: function () {
      var _stopRecording = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var _this5 = this;
        var recorder, fn;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              if (this.recorderVideoCallStreamCapture) {
                this.recorderVideoCallStreamCapture.stopCaptureVideoCallStreams();
                this.recorderVideoCallStreamCapture = null;
              }
              if (this.gameRecordCapturer) {
                this.is_recording_game = false;
                this.gameRecordCapturer.stopCaptureGameStream();
                this.gameRecordCapturer = null;
              }
              if (this.screenrecordControls) {
                this.screenrecordControls.remove();
                this.screenrecordControls = null;
              }

              //
              // Update the UI and tell peers the recording ended NOW -- the filename
              // prompt in downloadMedia can sit open indefinitely and must not delay
              // the stop notification
              //
              this.updateUIForRecordingStop();
              this.sendStopRecordingTransaction(this.members);
              this.members = [];
              if (!this.mediaRecorder) {
                _context13.n = 1;
                break;
              }
              recorder = this.mediaRecorder;
              this.mediaRecorder = null;
              fn = function fn() {
                return new Promise(function (resolve, reject) {
                  try {
                    recorder.onstop = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
                      var blob, hasVideo, url, _url;
                      return _regenerator().w(function (_context12) {
                        while (1) switch (_context12.n) {
                          case 0:
                            blob = new Blob(_this5.chunks, {
                              type: 'video/webm'
                            });
                            hasVideo = _this5.chunks.some(function (chunk) {
                              return chunk.type.includes('video') || chunk.type === 'video/webm';
                            });
                            if (!hasVideo) {
                              _context12.n = 2;
                              break;
                            }
                            console.log('chunk has video', _this5.chunks);
                            url = URL.createObjectURL(blob); // const url = await this.processVideo(this.chunks);
                            _context12.n = 1;
                            return _this5.downloadMedia(url, 'video');
                          case 1:
                            resolve();
                            _context12.n = 5;
                            break;
                          case 2:
                            _context12.n = 3;
                            return _this5.processAudio(blob);
                          case 3:
                            _url = _context12.v;
                            _context12.n = 4;
                            return _this5.downloadMedia(_url, 'audio');
                          case 4:
                            resolve();
                          case 5:
                            return _context12.a(2);
                        }
                      }, _callee12);
                    }));
                  } catch (error) {
                    reject();
                  }
                  recorder.stop();
                });
              };
              _context13.n = 1;
              return fn();
            case 1:
              return _context13.a(2);
          }
        }, _callee13, this);
      }));
      function stopRecording() {
        return _stopRecording.apply(this, arguments);
      }
      return stopRecording;
    }() //
    // Full-screen count-in overlay. Shown to the recorder before recording
    // starts and mirrored to everyone else in the call so nobody is surprised.
    //
  }, {
    key: "showCountdown",
    value: function showCountdown() {
      var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      var sender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var existingCountdown = document.getElementById('screenrecord-countdown-overlay');
      if (existingCountdown) {
        existingCountdown.remove();
      }
      var label = sender && sender !== this.publicKey ? "".concat(this.app.keychain.returnUsername(sender), " starts recording in") : 'Recording starts in';
      var countdown = document.createElement('div');
      countdown.id = 'screenrecord-countdown-overlay';
      countdown.className = 'screenrecord-countdown-overlay';
      countdown.setAttribute('aria-live', 'assertive');
      countdown.innerHTML = "\n\t\t\t<div class=\"screenrecord-countdown-label\">".concat(label, "</div>\n\t\t\t<div class=\"screenrecord-countdown-number\">").concat(seconds, "</div>\n\t\t");
      document.body.appendChild(countdown);
      var countNumber = countdown.querySelector('.screenrecord-countdown-number');
      var countLabel = countdown.querySelector('.screenrecord-countdown-label');
      var count = seconds;
      return new Promise(function (resolve) {
        var interval = setInterval(function () {
          count--;
          countNumber.textContent = count;
          if (count <= 0) {
            clearInterval(interval);
            countdown.classList.add('screenrecord-countdown-started');
            if (countLabel) {
              countLabel.textContent = 'Recording started';
            }
            setTimeout(function () {
              countdown.remove();
              resolve();
            }, 500);
          }
        }, 1000);
      });
    }
  }, {
    key: "sendCountdownTransaction",
    value: function () {
      var _sendCountdownTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var keys,
          seconds,
          newtx,
          _iterator,
          _step,
          peer,
          _args14 = arguments,
          _t5;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              keys = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : [];
              seconds = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : 5;
              _context14.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.publicKey);
            case 1:
              newtx = _context14.v;
              _context14.p = 2;
              newtx.msg = {
                module: 'screenrecord',
                request: 'recording countdown',
                seconds: seconds
              };
              _iterator = _createForOfIteratorHelper(keys);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  peer = _step.value;
                  if (peer != this.publicKey) {
                    newtx.addTo(peer);
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context14.n = 3;
              return newtx.sign();
            case 3:
              this.app.connection.emit('relay-transaction', newtx);
              _context14.n = 5;
              break;
            case 4:
              _context14.p = 4;
              _t5 = _context14.v;
              console.log('error sending recording countdown transaction', _t5);
            case 5:
              return _context14.a(2);
          }
        }, _callee14, this, [[2, 4]]);
      }));
      function sendCountdownTransaction() {
        return _sendCountdownTransaction.apply(this, arguments);
      }
      return sendCountdownTransaction;
    }()
  }, {
    key: "sendStartRecordingTransaction",
    value: function () {
      var _sendStartRecordingTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(keys) {
        var ongoing,
          newtx,
          _iterator2,
          _step2,
          peer,
          _args15 = arguments,
          _t6;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              ongoing = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : false;
              _context15.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.publicKey);
            case 1:
              newtx = _context15.v;
              _context15.p = 2;
              newtx.msg = {
                module: 'screenrecord',
                request: 'start recording',
                // true when notifying a late joiner that recording is already underway
                ongoing: ongoing
              };
              _iterator2 = _createForOfIteratorHelper(keys);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  peer = _step2.value;
                  if (peer != this.publicKey) {
                    newtx.addTo(peer);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _context15.n = 3;
              return newtx.sign();
            case 3:
              this.app.connection.emit('relay-transaction', newtx);
              this.app.network.propagateTransaction(newtx);
              _context15.n = 5;
              break;
            case 4:
              _context15.p = 4;
              _t6 = _context15.v;
              console.log('error sending start recording transaction', _t6);
            case 5:
              return _context15.a(2);
          }
        }, _callee15, this, [[2, 4]]);
      }));
      function sendStartRecordingTransaction(_x11) {
        return _sendStartRecordingTransaction.apply(this, arguments);
      }
      return sendStartRecordingTransaction;
    }()
  }, {
    key: "sendStopRecordingTransaction",
    value: function () {
      var _sendStopRecordingTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(keys) {
        var newtx, _iterator3, _step3, peer;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              _context16.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.publicKey);
            case 1:
              newtx = _context16.v;
              newtx.msg = {
                module: 'screenrecord',
                request: 'stop recording'
              };
              _iterator3 = _createForOfIteratorHelper(keys);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  peer = _step3.value;
                  if (peer != this.publicKey) {
                    newtx.addTo(peer);
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              _context16.n = 2;
              return newtx.sign();
            case 2:
              this.app.connection.emit('relay-transaction', newtx);
              this.app.network.propagateTransaction(newtx);
            case 3:
              return _context16.a(2);
          }
        }, _callee16, this);
      }));
      function sendStopRecordingTransaction(_x12) {
        return _sendStopRecordingTransaction.apply(this, arguments);
      }
      return sendStopRecordingTransaction;
    }()
  }, {
    key: "updateUIForRecordingStart",
    value: function updateUIForRecordingStart() {
      var remote_sender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var recordIcon = document.querySelector('.fa-record-vinyl');
      if (recordIcon) {
        console.log('updating UI for recording start');
        recordIcon.classList.add('recording');
        var container = recordIcon.parentElement;
        container.classList.add('recording');

        //
        // Recording is not exclusive -- the button stays clickable so you can
        // record too, but the label/tooltip say who is already recording
        //
        var label = container.querySelector('label');
        if (remote_sender) {
          container.title = "".concat(this.app.keychain.returnUsername(remote_sender), " is recording the call");
          if (label) label.innerText = 'Recording';
        } else {
          container.title = 'Stop recording';
          if (label) label.innerText = 'Stop';
        }
      }
      var recordingTarget = document.querySelector(this.recording_target_selector || '.video-container-large');
      if (recordingTarget) {
        recordingTarget.classList.add('screenrecord-recording-border');
      }
    }
  }, {
    key: "updateUIForRecordingStop",
    value: function updateUIForRecordingStop() {
      var recordIcon = document.querySelector('.fa-record-vinyl');
      if (recordIcon) {
        recordIcon.classList.remove('recording');
        var container = recordIcon.parentElement;
        container.classList.remove('recording');
        container.title = 'Record the call';
        var label = container.querySelector('label');
        if (label) label.innerText = 'Record';
      }
      document.querySelectorAll('.screenrecord-recording-border').forEach(function (recordingTarget) {
        recordingTarget.classList.remove('screenrecord-recording-border');
      });
      var recordButtonGame = document.getElementById('record-stream');
      if (recordButtonGame) {
        recordButtonGame.textContent = 'Record game';
      }
    }
  }]);
}(ModTemplate);
module.exports = Record;